var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 53,
    viewBox: "0 0 66 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_619_1385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0039 8.02037C26.176 10.4539 25.3011 12.8704 24.3792 15.2698C24.2634 15.5895 24.2646 15.792 24.511 16.0514C24.7788 16.3398 25.2831 16.533 25.6609 16.606C26.1548 16.7104 26.7008 16.7592 27.2039 16.6329C27.5062 16.5615 28.0503 16.4395 28.1694 16.1104C29.162 13.5451 30.1016 10.9499 30.9814 8.34376C31.0835 8.06168 30.6311 7.69579 30.4566 7.5901C30.0676 7.34287 29.5206 7.20864 29.0754 7.17509C28.3363 7.13084 27.2753 7.18272 27.0013 7.99816L27.0039 8.02037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.9321 11.1475L35.255 18.2184C35.1393 18.5381 35.1404 18.7406 35.3868 19C35.6546 19.2884 36.159 19.4816 36.5367 19.5546C37.0307 19.659 37.5767 19.7078 38.0797 19.5815C38.3726 19.5067 38.9261 19.3881 39.0452 19.059L41.7224 11.988C41.8381 11.6683 41.837 11.4658 41.5906 11.2064C41.3228 10.918 40.8184 10.7248 40.4407 10.6519C39.9467 10.5475 39.4007 10.4987 38.8977 10.625C38.6047 10.6997 38.0513 10.8184 37.9321 11.1475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.38887 23.836C7.29385 31.3222 13.3396 37.0952 20.5184 40.5026C27.6972 43.9101 36.74 44.6955 44.8353 43.0746C49.4809 42.1403 53.9152 40.4383 58.0668 38.1659C58.9717 37.664 57.9368 36.8213 57.4076 36.6085C56.4562 36.2108 55.2943 36.2474 54.3928 36.7399C48.1394 40.1763 40.8672 42.1378 33.7053 41.6505C26.5434 41.1632 20.1796 38.2955 15.1629 33.4693C12.267 30.6873 10.0146 27.3618 8.55101 23.6201C8.03142 22.294 3.79471 22.334 4.37947 23.8326L4.38887 23.836Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.73,
    height: 35.02,
    fill: "white",
    transform: "translate(12.625 0.55957) rotate(19.9034)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/Smiley.4397cdc83ca78c95c3417a5c569ecdfe.svg";
export { ForwardRef as ReactComponent };